import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "./components/Layout/Sidebar";
import Header from "./components/Layout/Header";
import AppRoutes from "./router/index.jsx";
import ErrorBoundary from "./components/common/ErrorBoundary";
import "./App.css";
import "./styles/unified-design-system.css";
import "./styles/theme-enhancements.css";
import "./styles/ui-enhancements.css";
import "./styles/page-enhancements.css";
import "./styles/mobile-enhancements.css";
import "./styles/page-specific-enhancements.css";
import "./styles/data-visualization-enhancements.css";
import "./styles/management-enhancements.css";

function App() {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <ErrorBoundary>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <div className="App">
          {isAuthenticated ? (
            <div className="admin-layout">
              <Sidebar />
              <div className="main-container">
                <Header />
                <main className="main-content">
                  <AppRoutes />
                </main>
              </div>
            </div>
          ) : (
            <div className="auth-layout">
              <AppRoutes />
            </div>
          )}
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
